// extracted by mini-css-extract-plugin
export var card = "card-module--card--ec4f1";
export var content = "card-module--content--9506d";
export var media = "card-module--media--49cab";